// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import {
  LoadingOutlined,
  HomeOutlined,
  NotificationFilled,
} from "@ant-design/icons";
import { Tabs, Radio, Row, Col } from "antd";
import ZenVerBarChart from "./Common/Graph/ZenVerBarChart";
import Angela1C from "./Common/Angela/Angela1C";
import RoutePage from "../RoutePage";




// import ZenClusterColVer from "./Common/Graph/ZenClusterColVer";
// import ZenClusterColHor from "./Common/Graph/ZenClusterColHor";
// import ZenPieBar from "./Common/Graph/ZenPieBar";
// import ZenHorBarChart from "./Common/Graph/ZenHorBarChart";
// import ZenWaterfallChart from "./Common/Graph/ZenWaterfallChart";
// import ZenPareto from "./Common/Graph/ZenPareto";
// import ZenVerStackBar from "./Common/Graph/ZenVerStackBar";
// import ZenHorStackBar from "./Common/Graph/ZenHorStackBar";
// import ZenVerCandleStick from "./Common/Graph/ZenVerCandleStick";
// import ZenHorCandleStick from "./Common/Graph/ZenHorCandleStick";

// import ZenGoldenTunnel from "./Common/Graph/ZenGoldenTunnel";
// import ZenGanttChart from "./Common/Graph/ZenGanttChart";
// import ZenStackedNePo from "./Common/Graph/ZenStackedNePo";
// import ZenDonut from "./Common/Graph/ZenDonut";
// import ZenGauge from "./Common/Graph/ZenGauge";
// import ZenSpectrum from "./Common/Graph/ZenSpectrum";
// import ZenRadar from "./Common/Graph/ZenRadar";

// import Angela1R from "./Common/Angela/Angela1R";
// import AngelaIcon1R from "./Common/Angela/AngelaIcon1R";
// import AngelaIconMultiR2C from "./Common/Angela/AngelaIconMultiR2C";
// import AngelaIconMultiR1C from "./Common/Angela/AngelaIconMultiR1C";

import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import digitalFactoryLogo from "../../images/DigitalFactory.png";
import { Link } from "react-router-dom";
// import RadialGradient from 'react-native-radial-gradient';

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class ZenChartArsenal extends React.Component {
  state = {
    mainData: null,
    ZenVerBarChart: null,
    Angela1C_MultiRow: null,


    // SnippetLineZenGaugeSingle: null,
    // SnippetLineZenGaugeAPQ: null,
    // SnippetLineZenGaugeAPQ_A: null,
    // SnippetLineZenGaugeAPQ_P: null,
    // SnippetLineZenGaugeAPQ_Q: null,
    // SnippetLineZenDonutTimeDistribution: null,
    // SnippetLineZenVerBarChartHourlyOEE: null,
    // ZenVerBarChartMultiColor: null,
    // ZenHorBarChart: null,
    // ZenWaterfallChart: null,
    // ZenClusterColVer: null,
    // ZenClusterColHor: null,
    // ZenVerStackBar: null,
    // ZenHorStackBar: null,
    // ZenVerCandleStick: null,
    // ZenHorCandleStick: null,
    // ZenGanttChart: null,
    // ZenPieBar: null,
    // ZenStackedNePo: null,
    // ZenDonut: null,
    // ZenPareto: null,
    // ZenRadar: null,
    // AngelaIconMultiR2C: null,
    // AngelaIconMultiR1C: null,
    // Angela1C_SingleRow: null,
   
    // Angela1R_SingleCol: null,
    // AngelaIcon1R_SingleCol: null,
    // AngelaIcon1R_SingleColDoubleLine: null,

    // ZenVerBarAndTrend: null,
    // ZenGoldenTunnel: null,
    // ZenSpectrum: null,

    // GtManpower: null,
    // GtLpg: null,
    // GtMseb: null,
    // ZenGauge: null,
    // GtHorCostContributor: null,
    // GaugeVBarB: null,
    // GaugeVBarG: null,

    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  onChange = (e) => {
    console.log("change--***");
    const st = this;
    this.setState({
      ...this.state,
      selectedTab: e.target.value,
      loading: true,
    });
    this.fetchTrendData(e.target.value);
  };

  changeLid = (lid) => {
    let val =
      this.state.lid === "all" ? lid : this.state.lid === lid ? "all" : lid;
    this.setState({ ...this.state, lid: val, dataLoading: true });
    this.fetchTrendData(this.state.selectedTab, val, this.state.selectedMnt);
  };

  getTabs() {
    liracrypt
      .get("/corp/corpdashdynamicparam", {})
      .then((response) => {
        let __tabs = response.data.data;
        this.setState(
          {
            tabsData: __tabs,
            selectedTab: __tabs?.find((x) => x.isDefault === true)?.subTyp,
          },
          () => {
            if (this._isMounted && this.state.selectedTab) {
              this.fetchTrendData(this.state.selectedTab);
            }
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.props.setPageHeader("Supplier 4M Change Management");
    this._isMounted = true;
    this.getTabs();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab, lid = "all", mnt = "all") => {
    liracrypt
      .get("/s4m/dashboard", {
        lid,
        mnt,
        typ: "MainGraph",
        subTyp: selectedTab,
        chartGroup: "S4MSUpplierDashboard",
      })
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["ZenVerBarChart"] = resp["data"]["ZenVerBarChart"];
        respData["Angela1C_MultiRow"] = resp["data"]["Angela1C_MultiRow"];


        // respData["SnippetLineZenGaugeSingle"] =
        //   resp["data"]["SnippetLineZenGaugeSingle"];
        // respData["SnippetLineZenGaugeOEE"] =
        //   resp["data"]["SnippetLineZenGaugeOEE"];
        // respData["SnippetLineZenGaugeAPQ"] =
        //   resp["data"]["SnippetLineZenGaugeAPQ"];
        // respData["SnippetLineZenGaugeAPQ_A"] =
        //   resp["data"]["SnippetLineZenGaugeAPQ_A"];
        // respData["SnippetLineZenGaugeAPQ_P"] =
        //   resp["data"]["SnippetLineZenGaugeAPQ_P"];
        // respData["SnippetLineZenGaugeAPQ_Q"] =
        //   resp["data"]["SnippetLineZenGaugeAPQ_Q"];
        // respData["SnippetLineZenDonutTimeDistribution"] =
        //   resp["data"]["SnippetLineZenDonutTimeDistribution"];
        // respData["SnippetLineZenVerBarChartHourlyOEE"] =
        //   resp["data"]["SnippetLineZenVerBarChartHourlyOEE"];
      
        // respData["ZenVerBarChartMultiColor"] =
        //   resp["data"]["ZenVerBarChartMultiColor"];
        // respData["ZenHorBarChart"] = resp["data"]["ZenHorBarChart"];
        // respData["ZenPareto"] = resp["data"]["ZenPareto"];
        // respData["ZenDonut"] = resp["data"]["ZenDonut"];
        // respData["ZenGauge"] = resp["data"]["ZenGauge"];
        // respData["GaugeVBarB"] = resp["data"]["GaugeVBarB"];
        // respData["GaugeVBarG"] = resp["data"]["GaugeVBarG"];
        // // respData["Angela"] = resp["data"]["Angela"];
        // respData["ZenSpectrum"] = resp["data"]["ZenSpectrum"];
        // respData["ZenRadar"] = resp["data"]["ZenRadar"];

        // respData["ZenPieBar"] = resp["data"]["ZenPieBar"];

        // respData["ZenVerStackBar"] = resp["data"]["ZenVerStackBar"];
        // respData["ZenHorStackBar"] = resp["data"]["ZenHorStackBar"];

        // respData["ZenVerCandleStick"] = resp["data"]["ZenVerCandleStick"];
        // respData["ZenHorCandleStick"] = resp["data"]["ZenHorCandleStick"];
        // respData["ZenWaterfallChart"] = resp["data"]["ZenWaterfallChart"];
        // respData["ZenClusterColVer"] = resp["data"]["ZenClusterColVer"];
        // respData["ZenClusterColHor"] = resp["data"]["ZenClusterColHor"];

        // // respData["ZenGanttChart"] = resp["data"]["ZenGanttChart"];
        // respData["ZenStackedNePo"] = resp["data"]["ZenStackedNePo"];
        // respData["ZenGoldenTunnel"] = resp["data"]["ZenGoldenTunnel"];
        // respData["AngelaIconMultiR2C"] = resp["data"]["AngelaIconMultiR2C"];

        // respData["AngelaIconMultiR1C"] = resp["data"]["AngelaIconMultiR1C"];

        // respData["Angela1C_SingleRow"] = resp["data"]["Angela1C_SingleRow"];
     
        // respData["Angela1R_SingleCol"] = resp["data"]["Angela1R_SingleCol"];
        // respData["AngelaIcon1R_SingleCol"] =
        //   resp["data"]["AngelaIcon1R_SingleCol"];

        // respData["AngelaIcon1R_SingleColDoubleLine"] =
        //   resp["data"]["AngelaIcon1R_SingleColDoubleLine"];
        // respData["ZenVerBarAndTrend"] = resp["data"]["ZenVerBarAndTrend"];
        // // respData["GtHorCostContributor"] = resp["data"]["GtHorCostContributor"];

        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  // changeBasicGraph(data) {
  //   let val =
  //     this.state.selectedMnt === "all"
  //       ? data._id
  //       : this.state.selectedMnt === data._id
  //         ? "all"
  //         : data._id;
  //   this.setState({
  //     selectedMnt: val,
  //     dataLoading: true,
  //   });
  //   this.fetchTrendData(this.state.selectedTab, this.state.lid, val);
  // }

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#000000",
              paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
            {/* <div
              style={{
                display: "inline-flex",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "space-around",
                width: "100%",
              }}
            >
              <div
                className="logo"
                style={{
                  margingLeft: 14,
                  padding: 10,
                }}
              >
                <img src={digitalFactoryLogo} alt="sarex" width="80" />
              </div>
              <Radio.Group
                className="managerTabs"
                value={"small"}
                onChange={this.onChange}
              >
                {this.state.tabsData &&
                  this.state.tabsData.map((tab, index) => (
                    <Radio.Button
                      key={index}
                      className={tab?.label?.toLowerCase()}
                      style={{
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        color: tab?.color,
                        textAlign: "center",
                        fontSize: "17px",
                        fontWeight: 600,
                        boxShadow: boxShadow,
                        maxWidth: "200px",
                      }}
                      value={tab?.subTyp}
                    >
                      {tab?.label}
                    </Radio.Button>
                  ))}
              </Radio.Group>
              <div
                style={{
                  //   boxShadow:
                  //     "rgb(30 30 30) 5px 5px 10px, rgb(46 46 46) -5px -5px 10px",
                  borderRadius: 10,
                  padding: 10,
                  marginRight: 25,
                  marginBottom: 13,

                  background: "#191C24",
                  //   backgroundImage:
                  //     "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,0.8748541652989321) 57%, rgba(33,32,40,1) 100%)",
                  border: "1px solid #3c3e4f",
                }}
              >
                <Link to="/dashboard">
                  <HomeOutlined
                    style={{
                      fontSize: 25,
                    }}
                  />
                </Link>
              </div>
            </div> */}
            {this.state.loading === false ? (
              <div>
                {this.state.mainData ? (
                  <div
                    style={{
                      margin: "10px",
                      padding: "10px",
                    }}
                  >
                    <div
                      style={{
                        color: "#9b59b6",
                        fontSize: 36,
                        fontWeight: 800,
                        textAlign: "center",
                        margin: "0px 0px 0px 0px",
                      }}
                    >
                     {/*  */}
                    </div>

                    {/* TEMPLATE ROW WITH COLUMNS     */}
                    <Row style={{ background: "#000000" }}>
                      <Col style={{ width: "25%" }}>
                      <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenVerBarChart
                            divId={"ZenVerBarChart1"}
                            // data={this.state.ZenVerBarChart.data}
                            // config={this.state.ZenVerBarChart.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                            api={'/s4m/dashboard'}
                            urlData={{
                              lid: 'all',
                              mnt: 'all',
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "S4MSUpplierDashboard",
                            }}
                          />
                        </div>
                      </Col>


                      <Col style={{ width: "25%" }}>
                      <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenVerBarChart
                            divId={"ZenVerBarChart2"}
                            // data={this.state.ZenVerBarChart.data}
                            // config={this.state.ZenVerBarChart.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                            api={'/s4m/dashboard'}
                            urlData={{
                              // lid: 'all',
                              // mnt: 'all',
                              // typ: "MainGraph",
                              // subTyp: this.state.selectedTab,
                              chartGroup: "S4MSUpplierDashboard",
                            }}
                          />
                        </div>
                      </Col>
                      <Col style={{ width: "25%" }}>
                      <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenVerBarChart
                            divId={"ZenVerBarChart3"}
                            // data={this.state.ZenVerBarChart.data}
                            // config={this.state.ZenVerBarChart.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                            api={'/s4m/dashboard'}
                            urlData={{
                              // lid: 'all',
                              // mnt: 'all',
                              // typ: "MainGraph",
                              // subTyp: this.state.selectedTab,
                              chartGroup: "S4MSUpplierDashboard",
                            }}
                          />
                        </div>
                      </Col>
                      <Col style={{ width: "25%" }}>
                      <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 20px",
                            width: "95%",
                          }}
                        >
                          <ZenVerBarChart
                            divId={"ZenVerBarChart4"}
                            // data={this.state.ZenVerBarChart.data}
                            // config={this.state.ZenVerBarChart.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                            api={'/s4m/dashboard'}
                            urlData={{
                              // lid: 'all',
                              // mnt: 'all',
                              // typ: "MainGraph",
                              // subTyp: this.state.selectedTab,
                              chartGroup: "S4MSUpplierDashboard",
                            }}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row style={{ background: "#000000" }}>
                      <Col style={{ width: "50%" }}>

                      <Row style={{ background: "#000000" }}>
                     

                      <Col style={{ width: "33%" }}>


                      <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #1677FF",
                            margin: "10px 0px 0px 10px",

                            width: "120px",
                          }}
                        >
                          <Angela1C
                            divId={"Angela01"}
                            api={'/s4m/dashboard'}
                            urlData={{
                              lid: 'all',
                              mnt: 'all',
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "S4MSUpplierDashboard",
                            }}
                            // data={this.state.Angela1C_MultiRow.data}
                            // config={this.state.Angela1C_MultiRow.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>


                      </Col>
                      <Col style={{ width: "33%" }}>

                        

                      <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #1677FF",
                            margin: "10px 0px 0px 10px",

                            width: "120px",
                          }}
                        >
                          <Angela1C
                            divId={"Angela02"}
                            api={'/s4m/dashboard'}
                            urlData={{
                              lid: 'all',
                              mnt: 'all',
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "S4MSUpplierDashboard",
                            }}
                            // data={this.state.Angela1C_MultiRow.data}
                            // config={this.state.Angela1C_MultiRow.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>

                      </Col>
                      <Col style={{ width: "33%" }}>


                        

                      <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #1677FF",
                            margin: "10px 0px 0px 10px",

                            width: "120px",
                          }}
                        >
                          <Angela1C
                            divId={"Angela03"}
                            api={'/s4m/dashboard'}
                            urlData={{
                              lid: 'all',
                              mnt: 'all',
                              typ: "MainGraph",
                              subTyp: this.state.selectedTab,
                              chartGroup: "S4MSUpplierDashboard",
                            }}
                            // data={this.state.Angela1C_MultiRow.data}
                            // config={this.state.Angela1C_MultiRow.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>

                      </Col>
                    </Row>
                    <Row style={{ background: "#000000" }}>
                     

                     <Col style={{ width: "33%" }}>


                     <div
                         style={{
                           borderRadius: "10px",
                           background: "#191C24",
                           border: "1px solid #1677FF",
                           margin: "10px 0px 0px 10px",

                           width: "120px",
                         }}
                       >
                         <Angela1C
                           divId={"Angela04"}
                           api={'/s4m/dashboard'}
                           urlData={{
                             lid: 'all',
                             mnt: 'all',
                             typ: "MainGraph",
                             subTyp: this.state.selectedTab,
                             chartGroup: "S4MSUpplierDashboard",
                           }}
                           // data={this.state.Angela1C_MultiRow.data}
                           // config={this.state.Angela1C_MultiRow.config}
                           onChange={(data) => this.changeBasicGraph(data)}
                         />
                       </div>


                     </Col>
                     <Col style={{ width: "33%" }}>

                       

                     <div
                         style={{
                           borderRadius: "10px",
                           background: "#191C24",
                           border: "1px solid #1677FF",
                           margin: "10px 0px 0px 10px",

                           width: "120px",
                         }}
                       >
                         <Angela1C
                           divId={"Angela05"}
                           api={'/s4m/dashboard'}
                           urlData={{
                             lid: 'all',
                             mnt: 'all',
                             typ: "MainGraph",
                             subTyp: this.state.selectedTab,
                             chartGroup: "S4MSUpplierDashboard",
                           }}
                           // data={this.state.Angela1C_MultiRow.data}
                           // config={this.state.Angela1C_MultiRow.config}
                           onChange={(data) => this.changeBasicGraph(data)}
                         />
                       </div>

                     </Col>
                     <Col style={{ width: "33%" }}>


                       

                     <div
                         style={{
                           borderRadius: "10px",
                           background: "#191C24",
                           border: "1px solid #1677FF",
                           margin: "10px 0px 0px 10px",

                           width: "120px",
                         }}
                       >
                         <Angela1C
                           divId={"Angela06"}
                           api={'/s4m/dashboard'}
                           urlData={{
                             lid: 'all',
                             mnt: 'all',
                             typ: "MainGraph",
                             subTyp: this.state.selectedTab,
                             chartGroup: "S4MSUpplierDashboard",
                           }}
                           // data={this.state.Angela1C_MultiRow.data}
                           // config={this.state.Angela1C_MultiRow.config}
                           onChange={(data) => this.changeBasicGraph(data)}
                         />
                       </div>

                     </Col>
                   </Row>


                    
              




                      </Col>

                      <Col style={{ width: "50%" }}>

                      <RoutePage params={{a:"123445" }} route={"/zen/table"} />




                      </Col>
                    
                    </Row>
                  </div>
                ) : null}

                <Col span={8} style={{}}></Col>

                <Col span={12}></Col>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>

          <Row style={{ background: "#000000" }}></Row>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default ZenChartArsenal;
